function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMotivation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-11",
    cx: 250.88,
    cy: 340.65,
    rx: 235.65,
    ry: 133.75,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-11"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-11",
    cx: 401.68,
    cy: 362.47,
    rx: 61.46,
    ry: 35.48,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-11",
    points: "31.26 321.33 265.71 456.69 374.91 393.65 140.46 258.28 31.26 321.33",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-11",
    d: "M304.13,296.62l-3.57-2.07c-2.43-1.4-2.43-3.67,0-5.07l8-4.6-28.83-16.64-8,4.6a9.72,9.72,0,0,1-8.79,0l-3.57-2.07c-2.43-1.4-2.43-3.67,0-5.07l24.17-13.95a9.7,9.7,0,0,1,8.78,0l3.58,2.06c2.42,1.4,2.42,3.67,0,5.07L287.1,264l28.83,16.65,8.8-5.08a9.7,9.7,0,0,1,8.78,0l3.58,2.06c2.42,1.4,2.42,3.67,0,5.07l-24.17,14A9.72,9.72,0,0,1,304.13,296.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-11",
    cx: 199.37,
    cy: 262.83,
    rx: 16.38,
    ry: 9.46,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottle--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Water--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M210.9,242.62a27.11,27.11,0,0,0-1.92-5c-.08-.18-.17-.36-.26-.54a10.15,10.15,0,0,1,.14-9.56l.17-.3a10.83,10.83,0,0,0,1.48-5.63,6.62,6.62,0,0,0-3.21-5.32,12.06,12.06,0,0,0-1.49-.72,2.55,2.55,0,0,1-1.62-2.36v-2.91l-9.32,0v2.91a2.53,2.53,0,0,1-1.63,2.35,10.34,10.34,0,0,0-1.5.71,6.63,6.63,0,0,0-3.25,5.3,10.81,10.81,0,0,0,1.43,5.63l.16.29a10.19,10.19,0,0,1,.08,9.58l-.27.53a27.13,27.13,0,0,0-1.95,4.94,23.63,23.63,0,0,0-.46,5l0,13.56c0,1.76,1.15,3.53,3.47,4.87a16,16,0,0,0,6.74,2,20.94,20.94,0,0,0,3.36,0,16.36,16.36,0,0,0,6.71-1.92c2.33-1.33,3.5-3.08,3.51-4.84l0-9.81c0-1.22.06-2.5.06-3.78A22.88,22.88,0,0,0,210.9,242.62Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.9,242.62a27.11,27.11,0,0,0-1.92-5c-.08-.18-.17-.36-.26-.54a10.15,10.15,0,0,1,.14-9.56l.17-.3a10.83,10.83,0,0,0,1.48-5.63,6.62,6.62,0,0,0-3.21-5.32,12.06,12.06,0,0,0-1.49-.72,2.55,2.55,0,0,1-1.62-2.36v-2.91l-9.32,0v2.91a2.53,2.53,0,0,1-1.63,2.35,10.34,10.34,0,0,0-1.5.71,6.63,6.63,0,0,0-3.25,5.3,10.81,10.81,0,0,0,1.43,5.63l.16.29a10.19,10.19,0,0,1,.08,9.58l-.27.53a27.13,27.13,0,0,0-1.95,4.94,23.63,23.63,0,0,0-.46,5l0,13.56c0,1.76,1.15,3.53,3.47,4.87a16,16,0,0,0,6.74,2,20.94,20.94,0,0,0,3.36,0,16.36,16.36,0,0,0,6.71-1.92c2.33-1.33,3.5-3.08,3.51-4.84l0-9.81c0-1.22.06-2.5.06-3.78A22.88,22.88,0,0,0,210.9,242.62Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.86,227.57l.17-.3a10.79,10.79,0,0,0,1.45-4.76,8.35,8.35,0,0,1-.88,1.92,18.27,18.27,0,0,1-4.21,4.39c-1.59,1.3-3.37,2.79-3.57,4.84s1.21,3.79,2.81,5,3.45,2,4.89,3.44a12.16,12.16,0,0,1,1.62,2,14.91,14.91,0,0,0-.24-1.49,27.11,27.11,0,0,0-1.92-5c-.08-.18-.17-.36-.26-.54A10.15,10.15,0,0,1,208.86,227.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,213.54v1.57a3.15,3.15,0,0,0,1.85,2.6,9.9,9.9,0,0,0,8.95,0,4.36,4.36,0,0,0,1.4-1.21,2.33,2.33,0,0,0,.46-1.37v-1.59a1.63,1.63,0,0,0-.05-.43,3.4,3.4,0,0,0-1.79-2.17l-.09,0a10,10,0,0,0-8.87,0,3.36,3.36,0,0,0-1.81,2.15A1.65,1.65,0,0,0,193.31,213.54Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,213.54v1.57a3.15,3.15,0,0,0,1.85,2.6,9.9,9.9,0,0,0,8.95,0,4.36,4.36,0,0,0,1.4-1.21,2.33,2.33,0,0,0,.46-1.37v-1.59a1.63,1.63,0,0,0-.05-.43,3.4,3.4,0,0,0-1.79-2.17l-.09,0a10,10,0,0,0-8.87,0,3.36,3.36,0,0,0-1.81,2.15A1.65,1.65,0,0,0,193.31,213.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.11,216.16c2.47-1.42,2.48-3.74,0-5.17a9.89,9.89,0,0,0-9,0c-2.48,1.42-2.49,3.73,0,5.17A9.92,9.92,0,0,0,204.11,216.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,211.71v.95a1.7,1.7,0,0,0,.05.44,3.37,3.37,0,0,0,1.79,2.16,8.8,8.8,0,0,0,4,1.07,9.35,9.35,0,0,0,5-1,4.33,4.33,0,0,0,1.4-1.2,2.43,2.43,0,0,0,.41-.94,1.54,1.54,0,0,0,.05-.43v-1a3.14,3.14,0,0,0-1.84-2.59,2.79,2.79,0,0,0-.34-.18,9.94,9.94,0,0,0-8.62.14A3.14,3.14,0,0,0,193.31,211.71Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,211.71v.95a1.7,1.7,0,0,0,.05.44,3.37,3.37,0,0,0,1.79,2.16,8.8,8.8,0,0,0,4,1.07,9.35,9.35,0,0,0,5-1,4.33,4.33,0,0,0,1.4-1.2,2.43,2.43,0,0,0,.41-.94,1.54,1.54,0,0,0,.05-.43v-1a3.14,3.14,0,0,0-1.84-2.59,2.79,2.79,0,0,0-.34-.18,9.94,9.94,0,0,0-8.62.14A3.14,3.14,0,0,0,193.31,211.71Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.31,211.68c0,2,2.82,3.65,6.32,3.67s6.34-1.61,6.35-3.62-2.82-3.65-6.32-3.66S193.32,209.67,193.31,211.68Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.46,208v3.28a.77.77,0,0,0,0,.15,1.18,1.18,0,0,0,.62.75,3,3,0,0,0,1.37.37,3.32,3.32,0,0,0,1.74-.36,1.43,1.43,0,0,0,.48-.42.83.83,0,0,0,.14-.32.39.39,0,0,0,0-.15V208a1.09,1.09,0,0,0-.63-.9l-.12-.06a3.44,3.44,0,0,0-3,.05A1.1,1.1,0,0,0,197.46,208Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.46,208v3.28a.77.77,0,0,0,0,.15,1.18,1.18,0,0,0,.62.75,3,3,0,0,0,1.37.37,3.32,3.32,0,0,0,1.74-.36,1.43,1.43,0,0,0,.48-.42.83.83,0,0,0,.14-.32.39.39,0,0,0,0-.15V208a1.09,1.09,0,0,0-.63-.9l-.12-.06a3.44,3.44,0,0,0-3,.05A1.1,1.1,0,0,0,197.46,208Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.46,207.94c0,.69,1,1.26,2.19,1.27s2.2-.56,2.2-1.26-1-1.26-2.19-1.27S197.47,207.24,197.46,207.94Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,207.94c0,.25.35.45.78.45s.78-.19.78-.44-.35-.45-.78-.45S198.88,207.7,198.88,207.94Z",
    style: {
      fill: "#FF725E",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.88,207.94c0,.25.35.45.78.45s.78-.19.78-.44-.35-.45-.78-.45S198.88,207.7,198.88,207.94Z",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Dumbbell--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dumbbell--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.44,238.59h0c-1.9-6.21-9.67-11.35-16.93-9.32h0a14.11,14.11,0,0,0-3.27,1.4c-7,4.06-12.75,13.94-12.75,22.08a13.29,13.29,0,0,0,.57,4h0c1.9,6.21,9.66,11.32,16.92,9.29h0a13.63,13.63,0,0,0,3.26-1.4c7-4.06,12.75-13.94,12.75-22.07A13.53,13.53,0,0,0,289.44,238.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,264.67c7-4.06,12.75-13.94,12.75-22.07s-5.71-11.43-12.75-7.37-12.74,14-12.74,22.08S270.21,268.74,277.25,264.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.25,244.25c2.71-1.56,4.91-.3,4.91,2.83a10.82,10.82,0,0,1-4.91,8.49c-2.7,1.56-4.9.3-4.9-2.83A10.84,10.84,0,0,1,277.25,244.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.93,248.94a3.73,3.73,0,0,1-1.67,2.91,1.23,1.23,0,0,1-1.13.15l-.12-.07a1.24,1.24,0,0,1-.44-1.05,3.73,3.73,0,0,1,1.69-2.91,1.21,1.21,0,0,1,1.12-.15l.12.07A1.22,1.22,0,0,1,278.93,248.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.86,264.49a3.68,3.68,0,0,1-1.68,2.9,1.4,1.4,0,0,1-.72.23,1.13,1.13,0,0,1-.56-.16L276.13,252l-.12-.07a1.24,1.24,0,0,1-.44-1.05,3.73,3.73,0,0,1,1.69-2.91,1.21,1.21,0,0,1,1.12-.15l.12.07,26.77,15.45A1.18,1.18,0,0,1,305.86,264.49Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.13,263.23h0c-1.91-6.21-9.67-11.35-16.93-9.31h0a13.81,13.81,0,0,0-3.27,1.39c-7,4.06-12.74,13.95-12.74,22.08a13.29,13.29,0,0,0,.57,4h0c1.9,6.22,9.66,11.33,16.92,9.29h0a13.75,13.75,0,0,0,3.26-1.39c7-4.07,12.75-13.95,12.75-22.08A13.2,13.2,0,0,0,332.13,263.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,289.32c7-4.07,12.75-13.95,12.75-22.08S327,255.81,320,259.87,307.2,273.82,307.2,282,312.91,293.38,320,289.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320,268.89c2.71-1.56,4.9-.29,4.9,2.83a10.81,10.81,0,0,1-4.9,8.49c-2.71,1.57-4.9.3-4.9-2.83A10.83,10.83,0,0,1,320,268.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.63,273.58a3.72,3.72,0,0,1-1.68,2.91,1.2,1.2,0,0,1-1.13.15l-.12-.07a1.22,1.22,0,0,1-.43-1.05,3.72,3.72,0,0,1,1.68-2.91,1.21,1.21,0,0,1,1.12-.15l.12.07A1.2,1.2,0,0,1,321.63,273.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.68,275.93a3.67,3.67,0,0,1-1.67,2.9,1.43,1.43,0,0,1-.73.23,1.13,1.13,0,0,1-.56-.16l-3.9-2.26-.12-.07a1.22,1.22,0,0,1-.43-1.05,3.72,3.72,0,0,1,1.68-2.91,1.21,1.21,0,0,1,1.12-.15l.12.07,3.9,2.25A1.18,1.18,0,0,1,325.68,275.93Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.68,275.92a3.71,3.71,0,0,1-1.67,2.91,1.23,1.23,0,0,1-1.13.15l-.12-.07a1.25,1.25,0,0,1-.43-1.05,3.75,3.75,0,0,1,1.68-2.92,1.17,1.17,0,0,1,1.12-.14l.12.07A1.2,1.2,0,0,1,325.68,275.92Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.73,102.91c-4.77,7.77-13.69,26.23-16.42,30.14-4.38-5.08-13.19-16.22-15.15-18.47-2.48-2.86-10.24-7.45-10.24-7.45l-2.64,11.65s17.06,26.78,22.18,31.88c3.25,3.25,7,5.31,14.63-2.77,7.12-7.53,24-30,24-30l.5-26.75C387.41,90.56,384.9,92.88,378.73,102.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.31,133.05c1.83,2,3.95,4.95,4.53,6.7a16.22,16.22,0,0,0-3.38-8.54Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.33,94.23l-6.84-4v37.64a4,4,0,0,1-1.37,2.37l6.84,3.95a4,4,0,0,0,1.37-2.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.49,105.47s-1.93.5-2.6,3.52-.93,8.78.83,10.64,4.15,2.63,5.7,1.92c2.91-1.34,1.89-7.27-.49-8.59-3.8-2.12-3.4-4.54-3.4-4.54Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.64,94.16l-2.88,3.67,0,25.71,3.11,5L332,134.23a3.65,3.65,0,0,0,1.37-2.37V99Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.89 128.5 341.89 130.08 331.96 135.81 331.96 134.23 341.89 128.5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.96 135.81 325.13 131.86 325.13 130.28 331.96 134.23 331.96 135.81",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.96 135.81 325.13 131.86 325.13 130.28 331.96 134.23 331.96 135.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,77.62h0c1.16-.7,2.77-.61,4.56.42l.07,0a14.15,14.15,0,0,1,6.4,11.08v.08c0,2.11-.77,3.58-2,4.21h0l-5.18,3-8.64-16.06Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,77.62h0c1.16-.7,2.77-.61,4.56.42l.07,0a14.15,14.15,0,0,1,6.4,11.08v.08c0,2.11-.77,3.58-2,4.21h0l-5.18,3-8.64-16.06Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.68,93.45h0l-5.18,3-2.86-5.32,9.44-5.46a11.23,11.23,0,0,1,.6,3.44v.08C344.68,91.35,343.91,92.82,342.68,93.45Z",
    style: {
      fill: "#FF725E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.47,81.55h0c1.32-.75,3.08-.72,5,.24a5.37,5.37,0,0,1,.62.33c.25.14.49.29.74.46a12.17,12.17,0,0,1,1.17.9,18,18,0,0,1,2,2,19.51,19.51,0,0,1,3.62,6.89,13.74,13.74,0,0,1,.53,3.63c0,2.5-.86,4.27-2.25,5.14l4.95-2.85h0a6.39,6.39,0,0,0,2.91-5.51,13.75,13.75,0,0,0-.48-3.48,19.24,19.24,0,0,0-3.67-7,15.1,15.1,0,0,0-2-2,12.29,12.29,0,0,0-1.17-.91c-.24-.16-.49-.32-.73-.46s-.42-.23-.63-.33a6.34,6.34,0,0,0-5.6.1h0l-.14.08-.17.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.87,98.31h0a6.39,6.39,0,0,0,2.91-5.51,13.75,13.75,0,0,0-.48-3.48l-5.65,3.08a13.74,13.74,0,0,1,.53,3.63c0,2.5-.86,4.27-2.25,5.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,86.75c0,5.12,3.59,11.35,8,13.91,2.23,1.29,4.25,1.4,5.7.54l.08,0c1.39-.87,2.25-2.64,2.25-5.14a17.72,17.72,0,0,0-8-13.9c-2.21-1.28-4.22-1.4-5.67-.57S320.11,84.19,320.11,86.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.11,86.75c0,5.12,3.59,11.35,8,13.91,2.23,1.29,4.25,1.4,5.7.54l.08,0c1.39-.87,2.25-2.64,2.25-5.14a17.72,17.72,0,0,0-8-13.9c-2.21-1.28-4.22-1.4-5.67-.57S320.11,84.19,320.11,86.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.5,85.43s8.09,4.15,15,16.14a52.37,52.37,0,0,1,3.28,6.68c3.48,8.52,3.19,14.39,3.19,14.39,2.41-5.91,5.42-12,10.42-16.72a76.68,76.68,0,0,1,6.16-5.15h0c1.32-.76,2.09-2.44,2.09-4.74a13.87,13.87,0,0,0-.9-4.71,18.23,18.23,0,0,0-1.37-2.94,16,16,0,0,0-5.5-5.81c-2-1.15-3.82-1.31-5.15-.55h0a74.65,74.65,0,0,1-7.53,2.76C308.62,86.75,301.82,86.29,295.5,85.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.5,85.43s8.09,4.15,15,16.14a52.37,52.37,0,0,1,3.28,6.68c3.48,8.52,3.19,14.39,3.19,14.39,2.41-5.91,5.42-12,10.42-16.72a76.68,76.68,0,0,1,6.16-5.15h0c1.32-.76,2.09-2.44,2.09-4.74a13.87,13.87,0,0,0-.9-4.71,18.23,18.23,0,0,0-1.37-2.94,16,16,0,0,0-5.5-5.81c-2-1.15-3.82-1.31-5.15-.55h0a74.65,74.65,0,0,1-7.53,2.76C308.62,86.75,301.82,86.29,295.5,85.43Z",
    style: {
      fill: "#fafafa",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79,108.25c3.48,8.52,3.19,14.39,3.19,14.39,2.41-5.91,5.42-12,10.42-16.72a76.68,76.68,0,0,1,6.16-5.15h0c1.32-.76,2.09-2.44,2.09-4.74a13.87,13.87,0,0,0-.9-4.71C328.61,94.38,318.68,100.05,313.79,108.25Z",
    style: {
      fill: "#FF725E",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.24,97a37.71,37.71,0,0,0,4.38,16.59h0c3.51,6.91,8.8,13.08,14.72,16.5,10.56,6.1,19.11,1.16,19.11-11a32.58,32.58,0,0,0-1.26-8.63,45.6,45.6,0,0,0-11.58-19.62c-.75-.73-1.51-1.43-2.3-2.07l-1-.79h0q-.71-.54-1.44-1t-1.53-1C288.79,79.86,280.24,84.8,280.24,97Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.62,113.57c3.51,6.91,8.8,13.08,14.72,16.5,10.56,6.1,19.11,1.16,19.11-11a32.58,32.58,0,0,0-1.26-8.63h0c-.71,1.57-3.28,3.82-4.42,2.25a29.52,29.52,0,0,1,1.1,7.66c0,3.5-.78,6.32-2.25,8.17a6.25,6.25,0,0,1-5.14,2.38,14.49,14.49,0,0,1-7-2.22c-5-2.91-9.68-8.13-13-14.06C286.48,114.59,285.82,115.15,284.62,113.57Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,97.66c0,5.38,1.89,11.46,4.94,16.93,3.28,5.93,7.92,11.15,13,14.06a14.49,14.49,0,0,0,7,2.22,6.25,6.25,0,0,0,5.14-2.38c1.47-1.85,2.25-4.67,2.25-8.17a29.52,29.52,0,0,0-1.1-7.66c-.27-1-.59-2-.95-3a43.38,43.38,0,0,0-2.25-5.11c-.18-.34-.36-.68-.55-1-.31-.56-.63-1.12-1-1.67a42.94,42.94,0,0,0-3.77-5.3l0,0a38.1,38.1,0,0,0-2.86-3.06c-.71-.68-1.43-1.32-2.17-1.91-.31-.25-.63-.49-.94-.72s-.77-.55-1.15-.8-.76-.48-1.14-.7a14.51,14.51,0,0,0-7-2.22C284.31,87.12,281.54,91.07,281.54,97.66Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.54,97.66c0,5.38,1.89,11.46,4.94,16.93,3.28,5.93,7.92,11.15,13,14.06a14.49,14.49,0,0,0,7,2.22,6.25,6.25,0,0,0,5.14-2.38c1.47-1.85,2.25-4.67,2.25-8.17a29.52,29.52,0,0,0-1.1-7.66c-.27-1-.59-2-.95-3a43.38,43.38,0,0,0-2.25-5.11c-.18-.34-.36-.68-.55-1-.31-.56-.63-1.12-1-1.67a42.94,42.94,0,0,0-3.77-5.3l0,0a38.1,38.1,0,0,0-2.86-3.06c-.71-.68-1.43-1.32-2.17-1.91-.31-.25-.63-.49-.94-.72s-.77-.55-1.15-.8-.76-.48-1.14-.7a14.51,14.51,0,0,0-7-2.22C284.31,87.12,281.54,91.07,281.54,97.66Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.78,100.66l6.7,12.51c1.89-.7,5.08-1.83,7.67-2.5-.11-.33-.22-.65-.34-1a44.46,44.46,0,0,0-2.25-5.12l-.55-1c-.31-.56-.63-1.12-1-1.67a42.08,42.08,0,0,0-3.77-5.29l0-.06-.61-.71A44.15,44.15,0,0,1,297.78,100.66Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.78,100.66l6.7,12.51c1.89-.7,5.08-1.83,7.67-2.5-.11-.33-.22-.65-.34-1a44.46,44.46,0,0,0-2.25-5.12l-.55-1c-.31-.56-.63-1.12-1-1.67a42.08,42.08,0,0,0-3.77-5.29l0-.06-.61-.71A44.15,44.15,0,0,1,297.78,100.66Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M303.92,113.14c1.52,0,2.42-1.22,2.42-3.27v-.06a11.2,11.2,0,0,0-5.06-8.77l0,0a4.39,4.39,0,0,0-2.12-.66c-1.51,0-2.42,1.23-2.42,3.28v.06a11.2,11.2,0,0,0,5.07,8.76l.05,0a4.41,4.41,0,0,0,2.11.65Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.92,113.14c1.52,0,2.42-1.22,2.42-3.27v-.06a11.2,11.2,0,0,0-5.06-8.77l0,0a4.39,4.39,0,0,0-2.12-.66c-1.51,0-2.42,1.23-2.42,3.28v.06a11.2,11.2,0,0,0,5.07,8.76l.05,0a4.41,4.41,0,0,0,2.11.65Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,77.89a1.5,1.5,0,0,0,1.51-1.51V61.81a1.51,1.51,0,1,0-3,0V76.38A1.5,1.5,0,0,0,296.69,77.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,81.45a1.51,1.51,0,0,0,1.31-.76l7.28-12.62a1.51,1.51,0,1,0-2.61-1.51l-7.29,12.62a1.5,1.5,0,0,0,.56,2.06A1.44,1.44,0,0,0,310,81.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.76,151.69a1.48,1.48,0,0,0,.75-.2,1.5,1.5,0,0,0,.55-2.06l-7.29-12.62a1.51,1.51,0,1,0-2.61,1.51l7.29,12.62A1.52,1.52,0,0,0,323.76,151.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,153.65a1.51,1.51,0,0,0,1.51-1.51V137.56a1.51,1.51,0,1,0-3,0v14.58A1.51,1.51,0,0,0,296.69,153.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.14,140a1.52,1.52,0,0,0,1.31-.75l7.29-12.63a1.51,1.51,0,0,0-2.62-1.51l-7.28,12.63a1.51,1.51,0,0,0,.55,2.06A1.53,1.53,0,0,0,276.14,140Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.1,125a1.48,1.48,0,0,0,.75-.2l12.62-7.29a1.51,1.51,0,1,0-1.5-2.61l-12.63,7.29a1.51,1.51,0,0,0,.76,2.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.59,104.42h14.58a1.51,1.51,0,0,0,0-3H255.59a1.51,1.51,0,1,0,0,3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.72,91.16a1.51,1.51,0,0,0,.75-2.82l-12.62-7.29a1.51,1.51,0,0,0-1.51,2.62L273,91A1.44,1.44,0,0,0,273.72,91.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.43,81.45a1.44,1.44,0,0,0,.75-.21,1.5,1.5,0,0,0,.56-2.06l-7.29-12.62a1.51,1.51,0,0,0-2.61,1.51l7.28,12.62A1.51,1.51,0,0,0,283.43,81.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.17,114.58c-3-3.59-3.12-5.87-5.4-7.61s-4.53-1.8-7.85-.78c-2.5.78-5.45.48-6.45,1.44-.29.2.2,1.8,1.39,2.36,1.44.66,3.73.45,5.42.42,3.86-.06.78,3.78,4.57,7.54C340.48,120.67,347.17,114.58,347.17,114.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.61,85.42C419,81,424.21,75.61,428,70.69c4.25-5.58,8.07-16.95-.13-24.4,0,0,.56-12.94-12.62-15.35C403.51,28.8,393.35,34.7,381,33c-6-.82-8.81,6.09-2.26,12.71,0,0-4.53,4.73-2,10.26s10.5,4.64,10.5,4.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.75,45A5.27,5.27,0,0,1,426,43.71a9.13,9.13,0,0,1,4.2-1.41A17.51,17.51,0,0,1,445,47.24c3.56,3.75,5,9.11,5.15,14.28s-.79,10.3-1.35,15.44a43.77,43.77,0,0,0-.08,10.79c.43,3,1.46,6.76,3.5,9.14,1.33,1.56,3.47,2.82,3.42,5.06s-2.07,3.41-4.13,3.74c-5.92.94-12.35-1.92-16-6.54-.2-.25-.38-.5-.56-.75-3.2-4.5-3.33-9.61-3.3-14.91,0-5.74,1.6-11.3,2.59-16.91A61.74,61.74,0,0,0,435.25,58c.05-1.83.07-4.09-1.06-5.65A5.72,5.72,0,0,0,428.83,50a6.12,6.12,0,0,1-2.65.18A3.12,3.12,0,0,1,424,47.5,3.87,3.87,0,0,1,424.75,45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.7,300l21.21-.38c-.32,14.16-2.57,29.87-2.94,43.15-.07,2.5.07,19.43-.88,24.58-1.41,7.73-10.59,6.68-11.08,2.06s.59-24.39.57-26.43c.08-8.52-3.92-22.9-6-38.19C421.47,304.08,420.79,300.78,420.7,300Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.56,372.67c-.19,4.54.21,7.6,1.54,10.41s4.28,3.95,7.42,3.48,7.27-2.14,8.54-5.95,1.36-6.5,1.08-10.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,341.19c1.25.23,1,6.33,1.13,12.47.12,6.59,1.79,9.47,1.95,14.88.19,6.18-.41,8.87-2.91,12.34s-10.43,6.33-13.63.67c-2.61-4.61-2.25-9.39-1.36-15.45.92-6.27,1.61-10.67,1.84-15.47.21-4.59.34-9,1.49-9.44,0,.68,0,1.54,0,2.21,0,.51-.1,3,.6,3.09a9,9,0,0,0,.19-1.72,2.09,2.09,0,0,1,.49-1.44,2.4,2.4,0,0,1,1.47-.48,34.47,34.47,0,0,1,3.81-.21c.63,0,1.26,0,1.89.11a5.09,5.09,0,0,1,1.58.39,1.11,1.11,0,0,1,.62.69,2.06,2.06,0,0,1,0,.7,4.51,4.51,0,0,0,0,1.27c0,.18.13.42.31.39s.23-.2.25-.35c.07-.73,0-1.28.09-2.14,0-.39,0-.94,0-1.34S439,341.58,439,341.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,366.78c0,.89.2,6.79-1.49,7.68s-2.32-3.71-2.32-3.71-3.9-1.64-10,.33c.2,1-1,4-2.56,3.18s-1.49-7.55-1.49-7.64c-.83,5.81-1.09,10.46,1.44,14.93,3.2,5.66,11.12,2.8,13.63-.67s3.1-6.16,2.91-12.34C442.1,367.92,442.06,367.34,442,366.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.69,371.09c-.19,2.21,2.06,1.68,2.47-1.42s-.56-10.66,0-16c-.12-6.14.12-12.24-1.13-12.47a1.8,1.8,0,0,0,0,.22l-.14,3.11c0,.45,0,.85-.06,1.32-.43,4.5-.67,13.25-.69,17.4A72,72,0,0,1,437.69,371.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.86,371.09a70.13,70.13,0,0,1-.42-7.85c0-4.12-.27-12.76-.68-17.29a12,12,0,0,1-.19-2.55c0-.63,0-1.41,0-2.07a.61.61,0,0,1,0-.14c-.83.31-1.12,2.74-1.3,5.8,0,1.78,0,4,.17,6.67.55,5.35-.42,12.95,0,16S429.06,373.3,428.86,371.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.51,328c.16-4.38-2.78-45.1-2.78-45.1l20.07,12.72c-4.31,25.74-5.23,31.81-5.31,36h0a3.57,3.57,0,0,1,.12,1.08c0,5-5.67,7.7-10.07,11a82,82,0,0,1-11.91,7.78c-3.2,1.6-9.69,1.75-10.5-.31,5.36-4.09,13.15-10.21,17.42-14.88C380.58,334.12,381.35,332.41,381.51,328Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,356.62c-.28,0-.6,2.74.89,4,1.73,1.48,6.69,4,13.37,3.17s10.3-2.75,13-5,6.42-5.39,9.44-6.06c2.81-.62,5.86-1.89,6.76-2.76s.77-4.73.77-4.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.54,330.44a1.08,1.08,0,0,1,1,.9c.2,1.06.43,4.16.87,5.9a31.57,31.57,0,0,1,.66,9.37c-.37,2-4.95,3.35-7.87,4.47a37.11,37.11,0,0,0-9.48,6c-3.14,2.59-9.74,5.28-14.09,5.25-5.16,0-11-1.7-12.28-4.09-1.65-3-.36-4.67,7.28-8.21,1.44-.67,6.52-3.68,8.25-4.77,4.69-2.94,9.33-7.05,11.48-12.27a2.9,2.9,0,0,1,1.1-1.59,2.4,2.4,0,0,1,1.48-.14,12.74,12.74,0,0,1,3.68,1.11c1,.49,2.48,1.06,2.46,2.37a4.47,4.47,0,0,1-.29,1.34c-.09.27-.16.62.07.78s.52,0,.72-.2a19.47,19.47,0,0,0,2.05-2.47,7.83,7.83,0,0,1,1.21-1.23,11.77,11.77,0,0,0,1.31-.85C393.63,331.63,393.51,331.05,393.54,330.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,357.06c1.34-1.1,2.75-2.16,4.17-3.11h0s-9,5.47-12.61,3c-2.34-1.6-1.23-3.54-1.17-4.16s-5.72-3.28-8-3.55h0c-.63.35-1.16.64-1.49.79-7.64,3.54-8.93,5.25-7.28,8.21,1.32,2.39,5.53,4.25,12.19,4.25C368.9,362.47,375.59,359.65,378.73,357.06Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.74,351c-4.75,1.9-2.72,2.79-1.39,3s9.33-4.48,14.2-8.34c5.09-4,8.29-8.42,10.18-9.9.71-.55,1.47-1.23,2.14-1.86-.12-1-.23-2-.32-2.5a1.08,1.08,0,0,0-1-.9c0,.61.09,1.19-.38,1.65a11.77,11.77,0,0,1-1.31.85,7.83,7.83,0,0,0-1.21,1.23,19.47,19.47,0,0,1-2.05,2.47C384.44,341.91,374.49,349.06,369.74,351Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.69,353.24a.5.5,0,0,1-.37-.17,10.42,10.42,0,0,0-7.87-3.09.47.47,0,1,1-.1-.94,11.38,11.38,0,0,1,8.7,3.43.46.46,0,0,1-.06.66A.5.5,0,0,1,368.69,353.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.83,350.69a.48.48,0,0,1-.36-.17,10.49,10.49,0,0,0-7.87-3.09.47.47,0,0,1-.11-.94,11.38,11.38,0,0,1,8.71,3.43.47.47,0,0,1-.07.66A.43.43,0,0,1,372.83,350.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,348.27a.45.45,0,0,1-.37-.17,10.47,10.47,0,0,0-7.87-3.09.48.48,0,0,1-.52-.42.46.46,0,0,1,.42-.51,11.33,11.33,0,0,1,8.7,3.43.47.47,0,0,1-.07.66A.45.45,0,0,1,377,348.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.82,345.52a.46.46,0,0,1-.37-.18,10.4,10.4,0,0,0-7.87-3.09.46.46,0,0,1-.52-.41.47.47,0,0,1,.42-.52,11.34,11.34,0,0,1,8.7,3.43.47.47,0,0,1-.07.66A.46.46,0,0,1,380.82,345.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.58,342.76a.46.46,0,0,1-.37-.18c-1.64-2.06-5.53-3.47-8.67-3.13A.46.46,0,0,1,375,339a.47.47,0,0,1,.41-.52c3.49-.38,7.66,1.15,9.51,3.48a.48.48,0,0,1-.08.66A.53.53,0,0,1,384.58,342.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.09,149.67c2.87,6.11,10.93,16.17,13.51,23,5.29,14.08,2.77,24.28,1.24,42.8-1.64,19.84-3.21,35.53-3.21,35.53.3,3.52,5.2,10.4,5.83,26,.59,14.57-1,33.09-1,33.09s-11,6.1-19.14-.06c0,0-7.85-37.48-10.15-55.72-2-15.92-4.3-28.77-4.3-28.77l-6.22,29.61s.44,8,1.1,14.78c1,10.73-5,31.79-5,31.79s-11.37,3.4-18.31-2.76c0,0-2.7-30.74-2.41-46,.32-17.35,3.35-75.52,5.48-100.32Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.09,149.67c2.87,6.11,10.93,16.17,13.51,23,5.29,14.08,2.77,24.28,1.24,42.8-1.64,19.84-3.21,35.53-3.21,35.53.3,3.52,5.2,10.4,5.83,26,.59,14.57-1,33.09-1,33.09s-11,6.1-19.14-.06c0,0-7.85-37.48-10.15-55.72-2-15.92-4.3-28.77-4.3-28.77l-6.22,29.61s.44,8,1.1,14.78c1,10.73-5,31.79-5,31.79s-11.37,3.4-18.31-2.76c0,0-2.7-30.74-2.41-46,.32-17.35,3.35-75.52,5.48-100.32Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.87,225.57l-4.25-34.68s-8.3-1.08-15.35-9.34c0,0,1.41,7.93,11.59,11.87l5.61,30.91-3.82,30.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,371.25a.46.46,0,0,1-.43-.29.48.48,0,0,1,.26-.62,15.73,15.73,0,0,1,10.5,0,.47.47,0,0,1-.33.88,14.89,14.89,0,0,0-9.82,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.46,366.36a.47.47,0,0,1-.16-.91,19.19,19.19,0,0,1,11.62,0,.49.49,0,0,1,.29.6.47.47,0,0,1-.6.3,18.59,18.59,0,0,0-11,0A.45.45,0,0,1,427.46,366.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,361.73a.45.45,0,0,1-.2,0c-5.08-2.32-10.79-.08-10.85-.06a.47.47,0,1,1-.35-.87c.25-.1,6.13-2.41,11.59.07a.47.47,0,0,1-.19.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.87,357.41a.48.48,0,0,1-.2,0,13.84,13.84,0,0,0-11-.13A.47.47,0,0,1,427,357a.46.46,0,0,1,.22-.63,14.59,14.59,0,0,1,11.81.13.47.47,0,0,1,.23.63A.46.46,0,0,1,438.87,357.41Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,352.56a.41.41,0,0,1-.21-.05c-5.2-2.57-11.05,0-11.11,0a.46.46,0,0,1-.62-.24.48.48,0,0,1,.24-.62c.25-.11,6.3-2.76,11.91,0a.47.47,0,0,1,.21.63A.46.46,0,0,1,439,352.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.65,92h0c4.09.28,11.54.94,11.54.94,4.29,2.39,5.38,4.36,6.17,10.06.34,2.42-1.63,8.9-3.33,18.09l-3.84,17.27-2.1,11.33c-5.06,4.43-12.32,7-25.84,7.13a34.63,34.63,0,0,1-16.7-4.13c-.19-8.08-1.36-16.14-1.52-20.86-6.38-5.23-8.52-13.87-5-19.5,8.09-13.09,15.94-21.33,21.15-20.9Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.36,131.9l1.38,8.64s6.37,4.08,21.24,3.48c20.69-.83,24.35-6.29,24.35-6.29,1.58-6,3-12.43,4.2-19.24a11.91,11.91,0,0,1-8.8-11,19.28,19.28,0,0,1,5-14.59l-10.14-.63s-19.11-1.29-22-1.14-7.56,3.41-13.05,10.5S368.46,121.13,380.36,131.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.57,131.45c-8.25-10-17.44-20.37-23.36-27.5-9.19-11.07-11-10.76-17.46-11.07-3.37,2.56-3.49,10.29,1,24.46,6.66,5.6,23.65,22.93,23.65,22.93-.75,1.8-7.93,14.91-12.56,20.47-.82,1-3.44,1.09-4.71,1.28a38.88,38.88,0,0,0-9.39,2.72c-2.29,1-3.81.79-3.83,1.41a2.82,2.82,0,0,0,2.81,2.62c1.1.13,3.93-.56,5.93-.88a16.87,16.87,0,0,1-3.84,2.59c-1.29.73-6.83,3.45-9,4.5-2.86,1.36-2.14,6.56,5.93,8.28,4.12.88,9.5.4,17.82-6.47,2.43-2,6-6.18,8.9-9.52,7.53-8.82,12.09-14.51,16.15-20.12C473.33,137.83,471.29,134.76,468.57,131.45Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.69,130.62s7.49,5.81,16,2.78a14.63,14.63,0,0,0,9.79-10.5s.91,9.77-9.87,13.1C397.24,139.21,391.69,130.62,391.69,130.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,65.17c.32,14.17,4.92,17.68,7.23,18.68s6.75.4,11.07-.32V92s-9,7.69-8.63,11.58,10.73,4.43,16.33.61c4.09-2.78,8.12-8.51,9.39-10a3,3,0,0,0,.72-2v-20a5.23,5.23,0,0,0,5.66-.84c3.84-3.29,4.09-8.5,1.29-11.29-1.35-1.35-4.87-1.74-7.09,1.59-1,4.37-2.88,5.23-4,3.87-5.2-6.61-6.85-3.55-14.45-8.09-8.77-5.24-10.28-10.84-12-16.34C383.94,43,381.11,48.45,381.5,65.17Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.26,63.34a1.65,1.65,0,0,0,1.54,1.77,1.67,1.67,0,0,0,1.71-1.61,1.63,1.63,0,1,0-3.25-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,63.34a1.65,1.65,0,0,0,1.54,1.77,1.67,1.67,0,0,0,1.71-1.61,1.63,1.63,0,1,0-3.25-.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "392.96 60.11 392.64 72.03 386.37 70.09 392.96 60.11",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.81,83.53c4.55-.6,13.93-3.29,15.39-7a9.62,9.62,0,0,1-3.29,4.73c-2.8,2.4-12.1,5.11-12.1,5.11Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.07,55.35l4.16,2.53a2.55,2.55,0,0,0-.85-3.43A2.37,2.37,0,0,0,399.07,55.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.86,72.18,394.31,75a3.28,3.28,0,0,0,4.32,1.36A3,3,0,0,0,399.86,72.18Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.21,76.27a2.5,2.5,0,0,0,.05.47,3,3,0,0,0,2.95-3.52A3.05,3.05,0,0,0,397.21,76.27Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.65,56.66,387.28,55a2.35,2.35,0,0,0-3-1.55A2.58,2.58,0,0,0,382.65,56.66Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mat--inject-11"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "31.26 315.44 265.71 450.81 374.91 387.76 140.46 252.39 31.26 315.44",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.26 315.44 265.71 450.81 374.91 387.76 140.46 252.39 31.26 315.44",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,401.31c5.13,2.86,8.93,7.69,14.68,9.32a27.49,27.49,0,0,0,17.77-1c2.45-1,4.86-2.5,6-4.86s.63-5.72-1.72-6.92a11.22,11.22,0,0,1-1.81-.88,1.34,1.34,0,0,1-.45-1.75c.51-.66,1.55-.34,2.31,0a23.49,23.49,0,0,0,21.87-1.5c1.86-1.18,3.67-2.82,4-5a6.3,6.3,0,0,0-2.22-5.42c-3-2.79-7.36-3.56-11.2-4.62l-13-3.57c-6.87-1.89-13.44-5.66-20-8.6-9.79-4.41-19.83-9-27.33-16.66-5.08-5.2-9-11.8-15.36-15.29-8.64-4.73-19.37-3-28.68-5.44-9.8-2.56-19.49-5.23-29.07-8.78a312.59,312.59,0,0,1-57.42-28.25,105.62,105.62,0,0,0,10-30.35c-6.37-2.23-12.54,3.28-18.82,5.74-4.92,1.93-9.84,1.85-14.75,1.1l-20.87,12c.87,3.07,2.26,6,3.21,9.1,1.45,4.65,1.61,10.42-2,13.66-2.09,1.87-5,2.49-7.73,3l-11.51,2.27c-3.28.65-7.06,1.69-8.34,4.78-1.56,3.78,1.76,7.81,5.25,9.94,6.49,4,14.24,5.27,21.39,7.89,16.78,6.12,29.92,19.33,45.55,28a92.09,92.09,0,0,0,35.18,11c12.75,1.29,25.75-.08,38.32,2.37,9.88,1.93,20,4.63,29.63,7.54a67.24,67.24,0,0,1,11.79,4.66c3.38,1.76,6.49,2.95,9,6.07,1.79,2.26,3.38,4.79,5.81,6.32s5.4,1.87,8.08,2.9A18.78,18.78,0,0,1,277.45,401.31Z",
    style: {
      fill: "#FF725E",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,401.31c5.13,2.86,8.93,7.69,14.68,9.32a27.49,27.49,0,0,0,17.77-1c2.45-1,4.86-2.5,6-4.86s.63-5.72-1.72-6.92a11.22,11.22,0,0,1-1.81-.88,1.34,1.34,0,0,1-.45-1.75c.51-.66,1.55-.34,2.31,0a23.49,23.49,0,0,0,21.87-1.5c1.86-1.18,3.67-2.82,4-5a6.3,6.3,0,0,0-2.22-5.42c-3-2.79-7.36-3.56-11.2-4.62l-13-3.57c-6.87-1.89-13.44-5.66-20-8.6-9.79-4.41-19.83-9-27.33-16.66-5.08-5.2-9-11.8-15.36-15.29-8.64-4.73-19.37-3-28.68-5.44-9.8-2.56-19.49-5.23-29.07-8.78a312.59,312.59,0,0,1-57.42-28.25,105.62,105.62,0,0,0,10-30.35c-6.37-2.23-12.54,3.28-18.82,5.74-4.92,1.93-9.84,1.85-14.75,1.1l-20.87,12c.87,3.07,2.26,6,3.21,9.1,1.45,4.65,1.61,10.42-2,13.66-2.09,1.87-5,2.49-7.73,3l-11.51,2.27c-3.28.65-7.06,1.69-8.34,4.78-1.56,3.78,1.76,7.81,5.25,9.94,6.49,4,14.24,5.27,21.39,7.89,16.78,6.12,29.92,19.33,45.55,28a92.09,92.09,0,0,0,35.18,11c12.75,1.29,25.75-.08,38.32,2.37,9.88,1.93,20,4.63,29.63,7.54a67.24,67.24,0,0,1,11.79,4.66c3.38,1.76,6.49,2.95,9,6.07,1.79,2.26,3.38,4.79,5.81,6.32s5.4,1.87,8.08,2.9A18.78,18.78,0,0,1,277.45,401.31Z",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.26 315.44 31.26 317.57 265.71 452.93 265.71 450.81 31.26 315.44",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "31.26 315.44 31.26 317.57 265.71 452.93 265.71 450.81 31.26 315.44",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.71 450.81 374.91 387.76 374.91 389.89 265.71 452.93 265.71 450.81",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.71 450.81 374.91 387.76 374.91 389.89 265.71 452.93 265.71 450.81",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81,325.2a22,22,0,0,1-10.32.64c-5.51-1-12.47-4.57-12-11.18a5.16,5.16,0,0,1,.61-2.18c1.24-2.18,4.13-2.58,6.55-3.27a18.24,18.24,0,0,0,10.91-8.78c2.47-4.6,2.82-10,2.52-15.25a19.2,19.2,0,0,1,.1-5,11.21,11.21,0,0,1,1.57-3.66,19.46,19.46,0,0,1,10.21-7.93,5.89,5.89,0,0,1,4.53-.11,2.81,2.81,0,0,1,1.46,2.62c-.13,1.19-1.42,1.94-2.16,2.78a12,12,0,0,0-3.25,7.45c0,2.74,1.13,5.33,2.1,7.89,3,8.07,4,17.46,0,25.13A22,22,0,0,1,81,325.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.72,288.85s6.74-48.52,5.41-66c-.68-9-5.29-11.8-11.92-11.29S109.1,233.7,109.1,233.7l5.36,13L146,236.83s-3.21,18.62-3.95,22.16-2.29,8.3-3.53,12.57a32.09,32.09,0,0,0-1.44,6.15C137.12,280.82,160.72,288.85,160.72,288.85Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,236.83c4.4-.86,8.79-3.45,10.17-5.52a9.62,9.62,0,0,1-4.4,5.52,38,38,0,0,1-6.34,3.29Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.49,334.62c-11.33-4.55-25.16-8.78-32.87-13.23s-8.14-5.6-16.78-10.65,2.26-24.41,2.26-24.41,16.14-5.58,23.76-8.59c4.83-1.12,10.43-3,16-2.75s16.28.13,20.29,3.82,3.86,11.3,3.86,11.3l12.94,13Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.45,293.57,170,290.11a3.92,3.92,0,0,1-.66-1.79c-2.23-.67-7.25-1.11-19.23,5.95-15.76,9.3-19.8,31.61-19.8,31.61h0c1.92.77,5,2,7.1,2.74,1.73-10.37,8.6-20.92,17.58-27.27A48.1,48.1,0,0,1,173.45,293.57Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.45,293.57,170,290.11a3.92,3.92,0,0,1-.66-1.79c-2.23-.67-7.25-1.11-19.23,5.95-15.76,9.3-19.8,31.61-19.8,31.61h0c1.92.77,5,2,7.1,2.74,1.73-10.37,8.6-20.92,17.58-27.27A48.1,48.1,0,0,1,173.45,293.57Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,300c2.43,8.33,1.35,13.07-.17,18.24h0l5.49,3.18A81.67,81.67,0,0,0,133.19,327c0-7.14,6.71-19.38,13.61-25.47,9.43-8.32,23.2-11.44,23.2-11.44s.15-7.61-3.86-11.3-13.15-4.1-18.39-4.11a99.09,99.09,0,0,0-10.22.55,57.69,57.69,0,0,0-8.57,2.84s11.51,1.28,5,4.61c-9,4.56-21.85,1.55-21.85,1.55a21.59,21.59,0,0,0-6,2.08S112.29,289.66,115.3,300Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,300c2.43,8.33,1.35,13.07-.17,18.24h0l5.49,3.18A81.67,81.67,0,0,0,133.19,327c0-7.14,6.71-19.38,13.61-25.47,9.43-8.32,23.2-11.44,23.2-11.44s.15-7.61-3.86-11.3-13.15-4.1-18.39-4.11a99.09,99.09,0,0,0-10.22.55,57.69,57.69,0,0,0-8.57,2.84s11.51,1.28,5,4.61c-9,4.56-21.85,1.55-21.85,1.55a21.59,21.59,0,0,0-6,2.08S112.29,289.66,115.3,300Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.64,375.16c-11.27-6.51-16.21-8.68-24.7-20.3-6.32-15.66-12.16-41.52-16.69-48.91-3.48-5.67-4.45-8.81-15.41-8.7-22.26.22-77.3,15.81-77.3,15.81l-21.39,9.17-3.72,6.67c3.88,4.13,10.91-1.16,18,2.55s9.09,11.15,19.47,10.28c20.77-1.76,33.09-7.16,43.85-11,9-3.23,20.11-6.61,20.11-6.61,1,5.78,2.4,10.19,6.77,16.8,5.8,8.76,7.19,10.33,11.49,17.58a6,6,0,0,0,1.11,2c1.1,2.06.95,5.62,1.12,8.08.66,9,4.36,2.78,17.2,13.85,3,2.59,5.82,4.75,9.84,5.64,3.57.79,8.1,0,11.63-.8,3.27-.78,4.26-2.11,6.3-5C340.15,379.66,333.61,376.87,330.64,375.16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.74,333.54s1.13-14.81,12.9-23.54c10.57-7.84,15.85-9.34,18.53-8.46s12.51,2.13,19.2,1.65c5-.37,45.6-7.21,72.13-7,10.49.1,14.17,2.78,17.48,12,3.37,9.34,8.7,28.29,8.7,28.29s-4.48,8.49-17.4,8.37a41.54,41.54,0,0,1-6.87-10,32.14,32.14,0,0,1-3-10s-39.22,21.78-60.59,24.61S150.74,333.54,150.74,333.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.27,314.25a21.11,21.11,0,0,0-4.06,7.73l-.34-1.21c-1.64-5.8-3.52-10.5-6.74-13.48s-6.19-3.92-13.55-3.54-50.26,7.72-50.26,7.72c-.94-3.27-2.66-4.13-2.66-4.13,1.16,2.62.65,6-1.16,7.43l-7.82,31.78c8.63,2.48,17.35,3.78,24.19,2.87,19-2.52,52.26-20.09,59.27-23.88l1.32-.73C272.23,321,274.27,314.25,274.27,314.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.16,371.24c-.76.43.25,3.8.84,4.61a10.32,10.32,0,0,0,5,2.76c2.89.72,5.43,2.27,8.42,4.87a33.74,33.74,0,0,0,11.16,6.29,21.44,21.44,0,0,0,15.89-.91c5.55-2.71,5.36-5.5,4.8-7.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,354.78l-.55-1.4c1-.61,4.07,3.73,8.14,8.22a50.8,50.8,0,0,0,10.5,9c8.28,4.59,11.28,5.35,14.21,7.82,3.77,3.16-.53,7.62-7.61,9.7-7.37,2.16-13.38-.61-17.94-3.38-3.2-1.94-7.85-5.74-10.2-7.33s-7.64-2.72-9.39-4.91c-1-1.2-.7-4.36-.94-7.13-.22-2.54-1.77-6.95-.9-7l1.12,2.05C298.71,362.09,306,358.25,305.91,354.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.91,354.78l-.55-1.4c1-.61,4.07,3.73,8.14,8.22a50.8,50.8,0,0,0,10.5,9c8.28,4.59,11.28,5.35,14.21,7.82,3.77,3.16-.53,7.62-7.61,9.7-7.37,2.16-13.38-.61-17.94-3.38-3.2-1.94-7.85-5.74-10.2-7.33s-7.64-2.72-9.39-4.91c-1-1.2-.7-4.36-.94-7.13-.22-2.54-1.77-6.95-.9-7l1.12,2.05C298.71,362.09,306,358.25,305.91,354.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.58,373.51A41.72,41.72,0,0,1,319,368c-5.26-4.16-11.57-12.32-13.12-13.19,0,0,0,0,0,.06,0,2.31-3.22,4.75-7.25,5.61,3.53-.64,10,7.72,13.08,10.78,4.16,4.15,7,6.5,8.9,6.61C323.18,375.52,325.63,374,327.58,373.51Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.69,377.49a.42.42,0,0,1-.28-.1.46.46,0,0,1-.09-.66c2.92-3.8,6-5.5,9.51-5.2a.47.47,0,1,1-.08.93c-3.14-.27-6,1.32-8.69,4.85A.46.46,0,0,1,316.69,377.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.86,374.67a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.91-3.8,6-5.51,9.51-5.2a.46.46,0,0,1,.42.5.47.47,0,0,1-.5.43c-3.14-.27-6,1.32-8.69,4.85A.46.46,0,0,1,312.86,374.67Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309,371.85a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.91-3.8,6-5.51,9.51-5.2a.47.47,0,0,1-.09.93c-3.13-.26-6,1.32-8.68,4.85A.46.46,0,0,1,309,371.85Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,368.7a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.92-3.8,6-5.5,9.51-5.2a.47.47,0,0,1,.43.5.48.48,0,0,1-.51.43c-3.15-.27-6,1.32-8.69,4.85A.46.46,0,0,1,305.56,368.7Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.7,364.93a.42.42,0,0,1-.28-.1.45.45,0,0,1-.09-.65c2.92-3.81,6-5.52,9.51-5.21a.47.47,0,1,1-.08.93c-3.13-.26-6,1.32-8.68,4.85A.49.49,0,0,1,302.7,364.93Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.65,391c-11.13-4.38-16.45-9.19-24.93-20.8-6.33-15.67-12.94-48.06-17.47-55.45-3.49-5.67-7.61-9.28-18.32-7.92C223.86,309.67,188.88,317,188.88,317l-15.08-6.62L151.55,333.5c5.89,3,8.54,7.73,14.67,12.14,6.51,4.69,9.89,7.81,20.27,8C203.33,354,217.2,344,228,340.13a100.42,100.42,0,0,0,17.56-8.76c.13,4.71,2.23,14.27,9.9,24.87a169.51,169.51,0,0,1,11.48,17.58,6,6,0,0,0,1.12,2.05c1.09,2.06.94,5.62,1.12,8.08.65,9.05,4.35,2.78,17.19,13.85,3,2.59,5.82,4.75,9.84,5.64a25.32,25.32,0,0,0,11.06-.2,9.59,9.59,0,0,0,6.88-5.64C316.25,393.39,309.84,392.27,306.65,391Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.32,358.87a15.28,15.28,0,0,1-2.19-2.56c-7.67-10.6-9.85-19.18-10-23.9,0,0-4.48,2.55-17.47,9.76-10,5.56-23,14.18-40.55,13.31-9-.46-15-4.12-21.4-9-4.34-3.32-7.4-8.76-15-12.95,2.75-8.87,4.61-20.3,21.85-27l22.91,8.21s26.31-6,48.46-8.21c14.28-1.41,15.91.33,19.39,6,4,6.61,7.79,22.05,12.45,38.52C274.59,353,265.57,359.5,257.32,358.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.84,386.73c-.76.44.25,3.81.84,4.62a10.4,10.4,0,0,0,5,2.76c2.89.72,5.43,2.27,8.42,4.87a33.74,33.74,0,0,0,11.16,6.29,21.44,21.44,0,0,0,15.89-.91c5.55-2.71,5.36-5.51,4.8-7.57Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.72,370.22l-.56-1.41c1-.61,3.95,3.8,8,8.29a50.8,50.8,0,0,0,10.5,9c8.28,4.59,11.28,5.35,14.21,7.82,3.77,3.16-.53,7.62-7.61,9.7-7.37,2.16-13.38-.61-17.94-3.38-3.2-1.95-7.85-5.74-10.2-7.33s-7.64-2.72-9.39-4.91c-1-1.2-.7-4.36-.94-7.13-.22-2.54-1.77-7-.9-7l1.12,2.05C274.39,377.59,281.81,373.68,281.72,370.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.72,370.22l-.56-1.41c1-.61,3.95,3.8,8,8.29a50.8,50.8,0,0,0,10.5,9c8.28,4.59,11.28,5.35,14.21,7.82,3.77,3.16-.53,7.62-7.61,9.7-7.37,2.16-13.38-.61-17.94-3.38-3.2-1.95-7.85-5.74-10.2-7.33s-7.64-2.72-9.39-4.91c-1-1.2-.7-4.36-.94-7.13-.22-2.54-1.77-7-.9-7l1.12,2.05C274.39,377.59,281.81,373.68,281.72,370.22Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.71,383.48c-5.26-4.17-11.45-12.26-13-13.13-.06,2.3-3.36,4.75-7.43,5.61h0c3.52-.75,10.07,7.69,13.14,10.76,4.16,4.16,7,6.51,8.9,6.62,2.55-2.33,5-3.87,6.95-4.34A41.72,41.72,0,0,1,294.71,383.48Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.37,393a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.92-3.8,6-5.5,9.51-5.2a.47.47,0,0,1,.43.5.48.48,0,0,1-.51.43c-3.14-.27-6,1.32-8.69,4.85A.46.46,0,0,1,292.37,393Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.54,390.17a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.92-3.8,6-5.5,9.51-5.21a.47.47,0,0,1-.08.94c-3.14-.27-6,1.32-8.69,4.84A.44.44,0,0,1,288.54,390.17Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,387.35a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.91-3.8,6-5.51,9.5-5.21a.48.48,0,0,1,.43.51.46.46,0,0,1-.51.43c-3.13-.27-6,1.31-8.68,4.84A.47.47,0,0,1,284.71,387.35Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.24,384.2a.46.46,0,0,1-.29-.1.47.47,0,0,1-.08-.66c2.92-3.8,6-5.51,9.51-5.21a.47.47,0,0,1,.42.51.46.46,0,0,1-.5.43c-3.15-.27-6,1.32-8.69,4.84A.44.44,0,0,1,281.24,384.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.38,380.43a.42.42,0,0,1-.28-.1.47.47,0,0,1-.09-.66c2.92-3.8,6-5.5,9.51-5.2a.47.47,0,0,1,.43.5.48.48,0,0,1-.51.43c-3.13-.27-6,1.32-8.68,4.85A.49.49,0,0,1,278.38,380.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.1,286.33s-27.51-14.7-31.86-16.68l24-14.14-5.1-13.26s-35.31,11.54-42.07,15.2c-3.57,1.92-5.6,4.7-5.61,7.44,0,4.58,2.68,10.28,8.7,15.42C67,291.24,86.1,301.64,103,311c5.68,3.07,12.09,7.23,12.09,7.23C117.06,314.13,119.47,299.94,106.1,286.33Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.24,269.65a43.79,43.79,0,0,1-13.06,4.55s7.23,1.85,15.87-3.17Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.16,233.41l-.18-.47c-5.58-14.47-14.89-14.83-30-8.84-11.18,4.44-20.11,12.76-20.7,24a27.19,27.19,0,0,0,9.62,22.05c6.76,5.72,15.92,7.38,27,3.11h0C135.19,270.83,139.73,247.87,134.16,233.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.94,229.23c3.45.58,9.65,6.31,15,21.27,4.55,12.68,1.68,17.35,0,19s-5.86,2.66-9.94,3.5l2.91,7.54-17.85,3.67-5.32-14s-1.41,3.06-6.53,1.19c-4.23-1.54-7.09-5.79-5.59-9.24a5.9,5.9,0,0,1,9.43-1.63s2.32-.68,3-5.73a18.25,18.25,0,0,0,9.86-6.57C123.12,240.47,122.21,232,121.94,229.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.58,252.44a1.72,1.72,0,0,1-1,2.23,1.75,1.75,0,0,1-2.2-1.09,1.69,1.69,0,1,1,3.19-1.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.05,242.73l-4.05-1a2,2,0,0,1,2.44-1.57A2.19,2.19,0,0,1,131.05,242.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.86,248.11l-3.09,2.79a2,2,0,0,1,.08-2.9A2.19,2.19,0,0,1,114.86,248.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,247a1.69,1.69,0,1,1-2.19-1.09A1.72,1.72,0,0,1,132,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.47,263.49a1.7,1.7,0,1,1-2.19-1.09A1.73,1.73,0,0,1,126.47,263.49Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.17 248.62 126.07 258.39 130.82 255.4 123.17 248.62",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,273c-4.25,1-13.48,1.84-16-1a9.12,9.12,0,0,0,4.53,3.07c3.3,1.17,12.48.39,12.48.39Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.06,260.54l2.55,6.61h0a4.83,4.83,0,0,0,2.77-6.23L107,254.81Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--go--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Go--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183,54.43a6.34,6.34,0,0,0-2.53-.11,4.46,4.46,0,0,0-1.85.75,4.35,4.35,0,0,0-1.27,1.39,10.56,10.56,0,0,0-.83,1.8,12.76,12.76,0,0,0-.44,1.52c-.16.66-.31,1.33-.46,2s-.28,1.39-.4,2.07-.2,1.21-.25,1.58a8.2,8.2,0,0,0,0,2,4.86,4.86,0,0,0,.61,1.8A4.51,4.51,0,0,0,177,70.69a6.58,6.58,0,0,0,2.34.93,8.55,8.55,0,0,0,2.16.19,5,5,0,0,0,1.9-.44,4.06,4.06,0,0,0,1.47-1.22,5.08,5.08,0,0,0,.9-2.09l-3.61-.78a1.15,1.15,0,0,1-.74-.52,1.13,1.13,0,0,1-.17-.89l1-4.55a1.15,1.15,0,0,1,.52-.75,1.17,1.17,0,0,1,.89-.16L194,62.64a1.12,1.12,0,0,1,.74.52,1.17,1.17,0,0,1,.17.89l-1.18,5.5a11.77,11.77,0,0,1-2.1,4.72,11,11,0,0,1-3.63,3.1,13.13,13.13,0,0,1-4.73,1.44,16.87,16.87,0,0,1-5.44-.32,15.75,15.75,0,0,1-5.32-2.1A13,13,0,0,1,168.91,73a11.12,11.12,0,0,1-1.85-4.28A13.12,13.12,0,0,1,167,64c.19-1.18.43-2.45.72-3.8s.6-2.63.92-3.84a12.2,12.2,0,0,1,2-4.27,11.49,11.49,0,0,1,3.44-3.15,12.67,12.67,0,0,1,4.69-1.63,17.51,17.51,0,0,1,11,2.31,14.44,14.44,0,0,1,3.6,3.11,11.11,11.11,0,0,1,2,3.53,7.08,7.08,0,0,1,.37,3.29.76.76,0,0,1-.4.61,1,1,0,0,1-.75.13l-5.71-1.22a1.33,1.33,0,0,1-.93-.61c-.19-.31-.37-.61-.54-.92A6.32,6.32,0,0,0,186,55.75,6.18,6.18,0,0,0,183,54.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,73.87c-.07.44-.17,1-.31,1.67s-.28,1.22-.4,1.64a10.36,10.36,0,0,1-1.78,3.67,10.19,10.19,0,0,1-3,2.65,11.33,11.33,0,0,1-4.09,1.34,14,14,0,0,1-4.91-.24,14.23,14.23,0,0,1-4.58-1.79,11.18,11.18,0,0,1-3.18-2.91,10.29,10.29,0,0,1-1.68-3.67,10.07,10.07,0,0,1-.11-4.06c.06-.44.16-1,.31-1.67s.27-1.22.39-1.64a9.7,9.7,0,0,1,1.74-3.68,10,10,0,0,1,3.06-2.64,11.73,11.73,0,0,1,4.11-1.37,15,15,0,0,1,9.5,2A11.87,11.87,0,0,1,219,66.14a9.87,9.87,0,0,1,1.68,3.67A10.45,10.45,0,0,1,220.81,73.87Zm-16.31-.26a3.74,3.74,0,0,0,.64,2.81,4.71,4.71,0,0,0,5.54,1.19,3.73,3.73,0,0,0,1.73-2.3,11.85,11.85,0,0,0,.4-1.45,11.58,11.58,0,0,0,.23-1.47,3.73,3.73,0,0,0-.64-2.81,4.08,4.08,0,0,0-2.57-1.52,4.16,4.16,0,0,0-3,.32,3.75,3.75,0,0,0-1.73,2.31,12.18,12.18,0,0,0-.4,1.44A12,12,0,0,0,204.5,73.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.21,88.07a1.21,1.21,0,0,1-1.41.91l-5.41-1.16a1.15,1.15,0,0,1-.75-.52,1.12,1.12,0,0,1-.16-.89l.93-4.34a1.15,1.15,0,0,1,.52-.74,1.12,1.12,0,0,1,.89-.17l5.41,1.16a1.15,1.15,0,0,1,.74.52,1.14,1.14,0,0,1,.17.89Zm2-9.24a1.15,1.15,0,0,1-.52.75,1.12,1.12,0,0,1-.89.16l-5.41-1.16a1.1,1.1,0,0,1-.74-.52,1.12,1.12,0,0,1-.17-.89l4-18.51a1.15,1.15,0,0,1,.52-.75,1.18,1.18,0,0,1,.89-.17l5.42,1.17a1.12,1.12,0,0,1,.74.52,1.16,1.16,0,0,1,.17.89Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--go--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.88,135.49a6.46,6.46,0,0,0-2.22,1.24,4.3,4.3,0,0,0-1.52,3.45,10.27,10.27,0,0,0,.23,2,12.84,12.84,0,0,0,.43,1.53c.21.64.44,1.3.68,2s.49,1.34.75,2,.46,1.14.62,1.49a8,8,0,0,0,1,1.68,4.67,4.67,0,0,0,1.46,1.2,4.39,4.39,0,0,0,2,.5,6.69,6.69,0,0,0,2.47-.44,8.58,8.58,0,0,0,1.94-1,4.77,4.77,0,0,0,1.38-1.38,4,4,0,0,0,.62-1.8,5.26,5.26,0,0,0-.34-2.26l-3.48,1.24a1.18,1.18,0,0,1-.9,0,1.15,1.15,0,0,1-.61-.67l-1.57-4.39a1.16,1.16,0,0,1,.05-.91,1.21,1.21,0,0,1,.67-.61l10-3.56a1.09,1.09,0,0,1,.9.05,1.15,1.15,0,0,1,.62.66l1.88,5.3a11.62,11.62,0,0,1,.7,5.12,11.06,11.06,0,0,1-1.45,4.55,12.91,12.91,0,0,1-3.28,3.71,16.79,16.79,0,0,1-4.79,2.59,15.88,15.88,0,0,1-5.63,1,13,13,0,0,1-4.86-1,11.16,11.16,0,0,1-3.82-2.68,13.28,13.28,0,0,1-2.56-4c-.45-1.11-.91-2.32-1.38-3.61s-.87-2.55-1.24-3.76a12.24,12.24,0,0,1-.55-4.68,11.75,11.75,0,0,1,1.27-4.49,12.66,12.66,0,0,1,3.14-3.84,17.48,17.48,0,0,1,10.54-3.8,14.61,14.61,0,0,1,4.7.75,11.39,11.39,0,0,1,3.54,2,7.21,7.21,0,0,1,2.05,2.6.82.82,0,0,1,0,.73,1,1,0,0,1-.57.51l-5.51,2a1.31,1.31,0,0,1-1.1,0c-.33-.16-.64-.33-.95-.5a5.46,5.46,0,0,0-5.3-.35Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.26,132.15c.17.41.37.94.61,1.58s.4,1.19.52,1.61a10.06,10.06,0,0,1-.78,7.9,11,11,0,0,1-2.76,3.3,15.4,15.4,0,0,1-9.15,3.26,11.11,11.11,0,0,1-4.23-.81,10.07,10.07,0,0,1-3.36-2.23,10,10,0,0,1-2.24-3.4c-.17-.4-.38-.93-.61-1.58s-.4-1.18-.52-1.61a9.43,9.43,0,0,1-.46-4,10.06,10.06,0,0,1,1.21-3.86,11.87,11.87,0,0,1,2.78-3.33,14,14,0,0,1,4.31-2.39,13.61,13.61,0,0,1,4.84-.86,11.7,11.7,0,0,1,4.26.81,9.88,9.88,0,0,1,3.36,2.23A10.47,10.47,0,0,1,225.26,132.15Zm-14,8.35a3.73,3.73,0,0,0,2,2.06,4.72,4.72,0,0,0,5.34-1.9,3.69,3.69,0,0,0,.27-2.87,14.5,14.5,0,0,0-.42-1.44,11.43,11.43,0,0,0-.59-1.38,3.7,3.7,0,0,0-2-2.06,4.74,4.74,0,0,0-5.34,1.91,3.69,3.69,0,0,0-.26,2.87,10.47,10.47,0,0,0,.42,1.43A10.25,10.25,0,0,0,211.25,140.5Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.55,130.39a1.13,1.13,0,0,1-.05.9,1.15,1.15,0,0,1-.67.61l-5.22,1.86a1.19,1.19,0,0,1-1.51-.72l-6.36-17.84a1.18,1.18,0,0,1,0-.9,1.2,1.2,0,0,1,.67-.62l5.22-1.85a1.13,1.13,0,0,1,.9,0,1.09,1.09,0,0,1,.61.67Zm3.17,8.9a1.13,1.13,0,0,1-.05.9,1.2,1.2,0,0,1-.67.62l-5.22,1.85a1.19,1.19,0,0,1-1.51-.72l-1.49-4.18a1.13,1.13,0,0,1,.05-.9,1.09,1.09,0,0,1,.67-.61l5.21-1.86a1.15,1.15,0,0,1,.91.05,1.12,1.12,0,0,1,.61.67Z",
    style: {
      fill: "#FF725E"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.47,211.24l-5.33-13.67,4.29-12.39v-7.59L90.3,185.18v7.58l5.64,13.43a.9.9,0,0,0,.39.34h0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.47,211.24l-5.33-13.67,4.29-12.39v-7.59L90.3,185.18v7.58l5.64,13.43a.9.9,0,0,0,.39.34h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.52,130.57a8.73,8.73,0,0,0-3.94-6.82l-3.21-1.85a8.73,8.73,0,0,0-7.87,0L74.08,145.14A8.72,8.72,0,0,0,70.15,152v44.59a8.72,8.72,0,0,0,3.93,6.83l3.21,1.85a8.75,8.75,0,0,0,7.88,0l13.37-7.69,5.64,13.4a.84.84,0,0,0,1.52-.14l6-20.84,13.92-8a8.7,8.7,0,0,0,3.94-6.83Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.15,196.55a8.72,8.72,0,0,0,3.93,6.83l3.21,1.85a8.8,8.8,0,0,0,7.2.31c-1.85.71-3.26-.34-3.26-2.59V158.36a8.1,8.1,0,0,1,1.15-3.88l-11.08-6.4A8.1,8.1,0,0,0,70.15,152Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.39,129.45c-.46-1.67-2-2.2-3.8-1.15L85.17,151.55a7.79,7.79,0,0,0-2.78,2.93l-11.08-6.39a8,8,0,0,1,2.78-2.94l40.4-23.25a8.75,8.75,0,0,1,7.88,0l3.22,1.86A8.7,8.7,0,0,1,129.39,129.45Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Heart--inject-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--heart--inject-11",
    d: "M88.5,170.91a24.06,24.06,0,0,1,2-9.32h0l0-.06c1.46-3.36,3.6-6.18,6-7.54,3.46-2,6.4,1.28,7.51,5.85.11.46.65.48.73,0,1-6,4.07-13,7.62-15,2.37-1.36,4.5-1,6,.68l0,0h0c1.25,1.46,2,3.87,2,7,0,9.73-5.87,18.46-10.78,27.65l-5.3,8.88-5-2.94C94.33,182.65,88.49,180.63,88.5,170.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,167.73l-2.27-5.94a.89.89,0,0,0-1.72.05l-3.5,13.62-2.79-7.63a.9.9,0,0,0-.86-.58h0a.88.88,0,0,0-.82.65l-2.07,7.37-7.21,4.16.17.25a11.26,11.26,0,0,0,.77,1l.15.18,7.32-4.23a.83.83,0,0,0,.4-.53l1.44-5.07,2.89,7.91a.88.88,0,0,0,.89.58.89.89,0,0,0,.81-.69l3.38-13.08,1.62,3.57a.87.87,0,0,0,.51.58.88.88,0,0,0,.79,0l5.76-3.33,0-.08c.28-.62.55-1.25.8-1.87l.3-.75Z",
    style: {
      fill: "#FF725E"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotivation);
export default __webpack_public_path__ + "static/media/motivation.a4abab6e057ed0305e80290a01f0f9db.svg";
export { ForwardRef as ReactComponent };